import { useEffect, useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrgPaymentHistory,
  getPaymentHistory,
} from "../../store/paymentHistory/paymentHistory.action";
import Table from "../../Component/Common/Table";
import dayjs from "dayjs";
import Pagination from "../../Component/Common/Pagination";
import { useNavigate } from "react-router-dom";

const paymentType = {
  subscription: "Plan Purchase",
  upgrade: "Plan Upgrade",
  certification: "Certificate",
};

const History = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { profile, tokenData } = useSelector((state) => state.loggedUser);
  const { paymentHistory, totalPaymentHistory } = useSelector(
    (state) => state.paymentHistory,
  );
  
  tokenData && tokenData.isOrg && profile &&
    profile.role !== "org_owner" &&
    navigate("/org/dashboard", { replace: true });

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);

  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };

  const paymentHistoryMapData = [
    {
      Header: "Item",
      Cell: ({ row }) => (
        <span className="text-capitalize fw-semibold">
          {row?.purchasedItem?.name ||
            row?.purchasedItem?.title ||
            (row.payer === "organization" ? "-" : "Premium Plan")}
        </span>
      ),
    },
    ...(!tokenData?.isOrg
      ? [
          {
            Header: "Payer",
            Cell: ({ row }) => (
              <span className="text-capitalize">{row?.payer || "-"}</span>
            ),
          },
        ]
      : []),
    ...(!tokenData?.isOrg
      ? [
          {
            Header: "Paid By",
            Cell: ({ row }) => (
              <span>
                {row.payer === "organization"
                  ? row?.organization?.name
                  : row?.user?.nickName || "-"}
              </span>
            ),
          },
        ]
      : []),

    {
      Header: "Amount",
      Cell: ({ row }) => (
        <span>
          {row?.currencySymbol} {row?.amount}
        </span>
      ),
    },
    {
      Header: "Discount",
      Cell: ({ row }) => <span>{row?.discount?.couponAmount || "-"}</span>,
    },
    {
      Header: "Amount Paid",
      Cell: ({ row }) => (
        <span>
          {row?.currencySymbol} {row?.paidAmount}
        </span>
      ),
    },
    {
      Header: "Paid For",
      Cell: ({ row }) => <span>{paymentType[row?.paymentType]}</span>,
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <span className="text-capitalize fw-semibold">
          {row?.createdAt ? dayjs(row?.createdAt).format("DD MMM YYYY") : "-"}
        </span>
      ),
    },
    // ...(!tokenData.isOrg
    //   ? [
    //       {
    //         Header: "Actions",
    //         Cell: ({ row }) => (
    //           <div className="d-flex items-align-center justify-content-center gap-2">
    //           </div>
    //         ),
    //       },
    //     ]
    //   : []),
  ];

  useEffect(() => {
    if (tokenData?._id) {
      if (tokenData.isOrg) {
        dispatch(getOrgPaymentHistory(page, size, startDate, endDate));
      } else {
        dispatch(getPaymentHistory(page, size, startDate, endDate));
      }
    }
  }, [tokenData, page, size, startDate, endDate]);

  return (
    <PageContainer>
      <PageHeader
        heading="Payment History"
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <Table
        data={paymentHistory}
        mapData={paymentHistoryMapData}
        noDataMessage="No Payment History Found!"
      />

      <div className="mt-3">
        <Pagination
          totalItem={totalPaymentHistory}
          activePage={page}
          pageSize={size}
          onActivePageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPage}
        />
      </div>
    </PageContainer>
  );
};

export default History;
